import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';

import { getColorContrast } from '../../core/helpers';
import { StyleBreakpoints } from '../../models/style-breakpoints';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { IImageBreakpoints } from '../../utils/responsive-image.component';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-image-text-split-spot',
    template: `
        <div class="image-text-split-spot has-background-color"
            [ngClass]="{
                'image-text-split-spot--align-right': data.alignImageRight
            }"
            [ngStyle]="{'background-color': data?.backgroundColor}">

            <div class="image-text-split-spot__columns" [ngClass]="{'image-fills-column': data?.imageFillsColumn}">
                <div class="image-text-split-spot__column media-column" [ngClass]="{'is-video-media': data?.videoId}">
                    <ng-container *ngIf="!data.videoId && data.spotImage">
                        <app-responsive-image
                            role="img"
                            [image]="data.spotImage"
                            [breakpoints]="imageBreakpoints"
                            [attr.aria-label]="data.spotImage.alt">
                        </app-responsive-image>
                    </ng-container>
                    <ng-container *ngIf="data.videoId" class="image-text-split-spot__image">
                        <app-youtube-player [videoId]="data.videoId!" [autoplay]="data.autoplayYoutubeVideo"></app-youtube-player>
                    </ng-container>
                </div>
                <div class="image-text-split-spot__column text-column {{colorClass}}" [ngClass]="{'has-text-spacing': data?.addTextSpacing}">
                    <app-rich-text [html]="data.spotText"></app-rich-text>
                </div>
            </div>
        </div>
    `,

    changeDetection: ChangeDetectionStrategy.OnPush,
})
class ImageTextSplitSpotComponent implements OnInit {
    /**
     * Since this spot is either from a regular grid *or* from the footer settings, we
     * use both the Umbraco type and the settings DTO.
     */
    @Input() data: Cms.ImageTextSplitSpot | Cms.ImageTextSplitSpotDto;

    imageBreakpoints: IImageBreakpoints[] = [{
        breakpoint: StyleBreakpoints.Xsmall,
        width: 410
    }, {
        breakpoint: StyleBreakpoints.Small,
        width: 718
    }, {
        breakpoint: StyleBreakpoints.Medium,
        width: 950
    }, {
        breakpoint: StyleBreakpoints.Large,
        width: 507
    }, {
        breakpoint: StyleBreakpoints.Xlarge,
        width: 630
    }];

    colorClass: string;

    ngOnInit() {
        if (this.data?.backgroundColor !== undefined && this.data?.backgroundColor !== '') {
            this.colorClass = getColorContrast(this.data?.backgroundColor);
        }
    }
}

@NgModule({
    declarations: [ImageTextSplitSpotComponent],
    imports: [CommonModule, UtilsModule, RichTextModule],
})
class ImageTextSplitSpotModule {}

export const LazySpotComponent = ImageTextSplitSpotComponent;
